import { useMembersContext } from '@/contexts/membersContext';
import ajax from '@/utils/ajax';

export interface TreatableTreatmentPreferenceParams {
  drug_category?: string;
  jurisdiction?: string;
}

export interface TreatableTreatmentPreference {
  label: string;
  value: string;
}

export const programRepository = {
  BASE_PATH: '/api/program/',

  async listTreatableTreatmentPreferences({
    host,
    params
  }: {
    host: string;
    params?: TreatableTreatmentPreferenceParams;
  }): Promise<TreatableTreatmentPreference[]> {
    const response = await ajax.get({
      url: `${host}${this.BASE_PATH}treatable-treatment-preferences/`,
      params: {
        ...params
      }
    });

    return response.data;
  }
};

export const ProgramRepository = () => {
  const { host } = useMembersContext();

  return {
    async listTreatableTreatmentPreferences(params: TreatableTreatmentPreferenceParams) {
      return programRepository.listTreatableTreatmentPreferences({ host, params });
    }
  };
};
